import { FeatureCardProps } from '~/types/featureCards'

export const SPLITS_CONNECT_CARD_ID = 'splits-connect'

export type FeatureCardSelection =
  | { type: 'published'; card: FeatureCardProps }
  | { type: 'splitsConnect' }
  | null

/**
 * Picks which card (if any) the sidebar slot shows for this page load.
 * An unread published card always wins; the Splits Connect promo is only a
 * candidate when nothing else wanted the slot at load time — dismissing the
 * published card mid-session must not pop the promo in until the next load.
 * The promo pick is additionally gated by the dashboard getting-started
 * state at render time (async — see FeatureCardSlot).
 */
export const pickFeatureCard = ({
  latestCard,
  dismissedIds,
  canInstallSplitsConnect,
}: {
  latestCard: FeatureCardProps | undefined
  dismissedIds: string[]
  canInstallSplitsConnect: boolean
}): FeatureCardSelection => {
  if (latestCard && !dismissedIds.includes(latestCard.id)) {
    return { type: 'published', card: latestCard }
  }

  if (
    canInstallSplitsConnect &&
    !dismissedIds.includes(SPLITS_CONNECT_CARD_ID)
  ) {
    return { type: 'splitsConnect' }
  }

  return null
}
